__turbopack_context__.v({
  "ctaButton": "EnterButton-module__ejub7G__ctaButton",
  "footerContent": "EnterButton-module__ejub7G__footerContent",
});
